// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2W6Ky","errorLogs":"EditorFooter_errorLogs__3CQLM"};